define(["require", "exports", "jquery", "../analytics", "../assetFilter", "../assetPicker"], function (require, exports, $, analytics_1, assetFilter_1, assetPicker_1) {
    "use strict";
    exports.__esModule = true;
    var TAG = 'filter-category';
    var Actions;
    (function (Actions) {
        Actions["open"] = "open";
        Actions["apply"] = "apply";
        Actions["clear"] = "clear";
    })(Actions || (Actions = {}));
    function default_1(show) {
        if (show === void 0) { show = false; }
        var $dlg = $('.filter-category-dialog');
        analytics_1["default"](TAG, Actions.open);
        if ($dlg.length === 0) {
            var choices = "<div class='filter-choices'></div>";
            var actions = '';
            $dlg = $("<div class=\"filter-category-dialog lock-zoom\">" + actions + choices + "</div>");
            $dlg.appendTo($('body'));
            assetFilter_1.setupFilter($dlg, $.extend({}, assetPicker_1.assetFilterOptions, {
                $assetContainer: $('body'),
                clearsInvisible: true,
                ensureFilterChoices: true,
                sel: '.featured-product-grid .item-box',
                getSortedList: function (c) { return c.find('.featured-product-grid > div:first-child'); },
                getSortedBox: function (b) { return b; }
            }));
        }
        if (show) {
            $dlg.dialog('show');
        }
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/filterCategory.js
// module id = 82
// module chunks = 0